import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import Breadcrumbs from 'components/Breadcrumbs';
import proxyAxios from '../../api/proxyAxios';
import { endpoints } from '../../api/endpoints';
import { Post } from '../../sections/Resources/FreightDictionary/Posts';
import { LandingsData } from '../../sections/Resources/FreightDictionary/data';

const Head = dynamic(() => import('sections/Resources/FreightDictionary/Head'));
const Terms = dynamic(() => import('sections/Resources/FreightDictionary/Terms'));

type FreightDictionaryProps = {
  articles: Post[];
}

export default function FreightDictionaryPage({ articles }: FreightDictionaryProps) {
  return (
    <div className="freight-dictionary">
      <Head />
      <Terms />
      <div className="container">
        <Breadcrumbs mode="dark" links={[{ title: 'Freight Dictionary', href: '' }]} />
      </div>
    </div>
  );
}

export const getStaticProps = async () => {
  const pageProps: any = {
    title: 'Freight Dictionary | Logistics & Shipping Terms | DF Alliance',
    description:
      'Learn & understand freight shipping terms used in the industry to boost your supply chain terminology. Get a detailed explanation of all freight shipping terms.',
    keywords: 'Freight dictionary, freight terms, shipping terms',
    path: '/freight-dictionary',
    landingsData: LandingsData,
  }

  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3&order=random');
    return {
      props:
        {
          articles,
          ...pageProps,
        }
    };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return {
    props: {
      articles: [],
      ...pageProps,
    }
  }
};

FreightDictionaryPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
